'use strict';
var slickConfigs = require('../config/slickConfigs'),
    $ = window.$,
    frontendKit = require('../frontend/utils');


var runOnLoading = frontendKit.debounce(
    function() {
        if ($('.product-carousel.slick-initilized').length || $('.product-carousel-nav.slick-initilized').length) return;

        $('.product-carousel.slick-initialized, .product-carousel-nav.slick-initialized').slick('unslick');
        $('.product-carousel').slick(slickConfigs.detail);
        $('.product-carousel-nav').slick(slickConfigs.detailNav);
    }, 1000
)
/**
 * Init globally reusable carousels
 */

module.exports = {
    productDetailCarousel: function() {
        $('body').on('apply:slick', runOnLoading);
    }
};
